import React, { useContext } from "react";

import { Trans } from "app/utils";

import { Icon } from "@culturehq/components";
import StoryFilterBar from "components/admin/settings/StoryFilterBar";
import { StoryModalContext } from "components/stories/video-studio/contexts/StoryContext";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";


const StoriesTitle: React.FC = () => {
  const {
    isControlledModeStories,
    onSelectFilters,
    selectedFilters,
    selectedStories
  } = useContext(StoryModalContext);
  const { data: { storyQuestionId } } = useContext(CreatomateContext);
  const isControlledMode = !!storyQuestionId || isControlledModeStories;

  const handleSelectedTags = (selectedOptions: any, _: any) => {
    onSelectFilters(selectedOptions);
  };

  const handleClearSelectedOptions = () => {
    onSelectFilters([]);
  };

  return (
    <div className="Stories-Container__Header">
      <h2 className="Stories-Container__Title">
        {selectedStories?.length === 0
          ? <Icon className="Required-Icon" icon="info" />
          : <Icon className="Completed-Icon" icon="ios-checkmark" />}
        <Trans>Select stories to include</Trans>
      </h2>
      {!isControlledMode && (
        <StoryFilterBar
          selectedOptions={selectedFilters}
          handleClearSelectedOptions={handleClearSelectedOptions}
          handleSelectedTags={handleSelectedTags}
        />
      )}
    </div>
  );
};

export default StoriesTitle;
